import { Directive, Input } from '@angular/core';

@Directive({
    selector: '[ngInit]',
    exportAs: 'ngInit'
})
export class NgInitDirective {
    @Input() public ngInit: any;

    public ngOnInit() {
        if (this.ngInit) {
            this.ngInit();
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/directives/ng-init.directive.ts